import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import { keys } from '@/lib/queryKeys';
import { fetchAdmissionList, type AdmissionListQuery } from './api';

/** Branch-scoped (branchKey + branchVersion), so a branch switch refetches. */
export function useAdmissionList(query: AdmissionListQuery, opts: { enabled?: boolean } = {}) {
  const { branchVersion } = useAuth();
  return useQuery({
    queryKey: [...keys.ip.admissions({ ...query }), branchVersion],
    queryFn: () => fetchAdmissionList(query),
    placeholderData: (prev) => prev,
    enabled: opts.enabled ?? true,
  });
}
